import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import './node_modules/@rebrandly/styleguide/dist/index.css'
import './src/styles/normalize.css'
import './src/styles/components.css'
import './src/styles/global.css'
import './src/styles/tooltip.css'
import './src/styles/common.css'
import './src/styles/lightbox.css'

const RECAPTCHA_SITE_KEY = '6LcKApAqAAAAAHavw1V1f5eliKzxKcnEV6Dwo00x'

export const wrapRootElement = ({ element }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head'
      }}
    >
      {element}
    </GoogleReCaptchaProvider>
  )
}

export const onClientEntry = () => {
  window.addEventListener('load', () => {
    document.body.className = document.body.className.replace(/\bno-js\b/, '')
  })

  if (typeof window !== 'undefined') {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://app.termly.io/embed.min.js'
    script.setAttribute('data-auto-block', 'off')
    script.setAttribute('data-website-uuid', '9aa384fe-05da-4d4f-a1a6-1a6c4be0b6fd')

    script.onload = () => {
      const checkTermly = setInterval(() => {
        if (window.Termly) {
          clearInterval(checkTermly)

          window.Termly.on('initialized', () => {
            window.dispatchEvent(new Event('termly_loaded'))
          })

          window.Termly.on('consent', () => {
            window.dispatchEvent(new Event('termly_consent_changed'))
          })
        }
      }, 100)
    }

    document.head.appendChild(script)
  }
}
